<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  label: { type: String, required: true },
  value: { type: [Number, String], required: true },
  change: { type: Number, default: null },
});

const { t } = useI18n();

const trendArrow = computed(() => (props.change >= 0 ? '↑' : '↓'));
const trendPct = computed(() => `${Math.abs(props.change)}%`);
</script>

<template>
  <div
    class="bg-white rounded-lg border border-[#E8E6E0] border-t-4 border-t-[#1B2A4A] p-4 flex flex-col gap-1.5"
  >
    <p class="text-xs font-semibold text-slate-500 uppercase tracking-wider">
      {{ label }}
    </p>
    <p class="text-3xl font-bold text-[#1B2A4A]">
      {{ value.toLocaleString() }}
    </p>
    <p
      v-if="change !== null"
      :class="change >= 0 ? 'text-green-600' : 'text-red-600'"
      class="text-xs font-medium"
    >
      {{ trendArrow }} {{ trendPct }}
      {{ t('MINISTRY.REPORT.METRIC_CARD.VS_PRIOR') }}
    </p>
  </div>
</template>
